import { defineStore } from "pinia";
import { ref } from "vue";

import drawLines from "@/assets/draw-lines.gif";
import type { BoardType } from "@/model/baseTypes";
import { isBacklogBoard, isObjectivesBoard } from "@/model/board";
import type { Line, LineComponent, RelativeCoordinate } from "@/model/coordinates";
import type { Shape } from "@/model/shape";
import { asReadonly } from "@/utils/vue";

import { toggled } from "./helpers/toggle";
import { useToastStore } from "./toast";

type SelectedShape = { shape: Shape } & Selected;

export type Selected =
  | { anchor: LineComponent | null }
  | { anchor: "line"; offset: Line<RelativeCoordinate> };

export const useDrawStore = defineStore("draw", () => {
  const active = ref(false);
  const selected = ref<SelectedShape | null>(null);

  function updateSelected() {
    if (active.value) {
      useToastStore().show(/*$t*/ "message.lineTool", {
        titleKey: /*$t*/ "action.lineTool",
        imageUrl: drawLines,
        closeable: true,
      });
    } else {
      selected.value = null;
    }
  }

  return {
    active: asReadonly(active),
    selected,

    isSupportedBoard: (boardType: BoardType) =>
      !isObjectivesBoard(boardType) && !isBacklogBoard(boardType),
    toggle: (activate?: boolean) => {
      active.value = toggled(active, activate);
      updateSelected();
    },
    unselect: () => (selected.value = null),
  };
});
